import { gql } from "@apollo/client/core";

export const GET_PICKUP_STOCK_SITES = gql`
  query (
    $distributorId: ID!
    $stockSiteInput: StockSiteInput
    $timeSlotInput: TimeSlotInput
    $eligibility: EligibilityInformationInput
  ) {
    pickupStockSites: getStockSites(
      distributorId: $distributorId
      stockSiteInput: $stockSiteInput
    ) {
      nodes {
        stockSiteId
        distributorId
        name
        formattedAddress
        formattedName
        paymentMethods
        pickUpTimeSlots(timeSlotInput: $timeSlotInput, eligibility: $eligibility) {
          specificTimes {
            twelveHour
          }
          date {
            formattedDate
            dateString
          }
        }
        pickUpDates(timeSlotInput: $timeSlotInput, eligibility: $eligibility)
      }
    }
  }
`;

export const GET_DELIVERY_STOCK_SITES = gql`
  query (
    $distributorId: ID!
    $stockSiteInput: StockSiteInput
    $timeSlotInput: TimeSlotInput
    $eligibility: EligibilityInformationInput
  ) {
    deliveryStockSites: getStockSites(
      distributorId: $distributorId
      stockSiteInput: $stockSiteInput
    ) {
      nodes {
        stockSiteId
        distributorId
        name
        formattedAddress
        formattedName
        paymentMethods
        deliveryTimeSlots(timeSlotInput: $timeSlotInput, eligibility: $eligibility) {
          specificTimes {
            twelveHour
          }
          date {
            formattedDate
            dateString
          }
        }
        deliveryDates(timeSlotInput: $timeSlotInput, eligibility: $eligibility)
      }
    }
  }
`;

export const GET_DELIVERY_AND_PICKUP_STOCK_SITES = gql`
  query (
    $distributorId: ID!
    $stockSiteInput: StockSiteInput
    $timeSlotInput: TimeSlotInput
    $eligibility: EligibilityInformationInput
    $stockSiteInput2: StockSiteInput
  ) {
    deliveryStockSites: getStockSites(
      distributorId: $distributorId
      stockSiteInput: $stockSiteInput
    ) {
      nodes {
        stockSiteId
        distributorId
        name
        formattedAddress
        formattedName
        paymentMethods
        deliveryTimeSlots(timeSlotInput: $timeSlotInput, eligibility: $eligibility) {
          specificTimes {
            twelveHour
          }
          date {
            formattedDate
            dateString
          }
        }
        deliveryDates(timeSlotInput: $timeSlotInput, eligibility: $eligibility)
      }
    }
    pickupStockSites: getStockSites(
      distributorId: $distributorId
      stockSiteInput: $stockSiteInput2
    ) {
      nodes {
        stockSiteId
        distributorId
        name
        formattedAddress
        formattedName
        paymentMethods
        pickUpTimeSlots(timeSlotInput: $timeSlotInput, eligibility: $eligibility) {
          specificTimes {
            twelveHour
          }
          date {
            formattedDate
            dateString
          }
        }
        pickUpDates(timeSlotInput: $timeSlotInput, eligibility: $eligibility)
      }
    }
  }
`;

export const GET_STOCK_SITE_DETAILS = gql`
  query ($distributorId: ID!, $stockSiteId: ID) {
    getStockSite(distributorId: $distributorId, stockSiteId: $stockSiteId) {
      formattedAddress
      formattedName
      name
      storeEmail
      storePhone
      storeWebsite
      region
      pickupEnabled
    }
  }
`;
